<template>
  <div
    v-if="!edit"
    class="single-comment d-flex flex-column justify-space-between ga-3"
  >
    <div class="header w-100 d-flex align-center justify-space-between">
      <div class="user-data d-flex align-center ga-2">
        <img class="circle-img" :src="comment.image" :alt="comment.user" />
        <span class="name d-flex">{{ comment.user }}</span>
      </div>

      <div class="time d-flex align-center ga-2">
        <span>{{ comment.time }}</span>
        <v-menu>
          <template v-slot:activator="{ props }">
            <span class="status-menu cursor-pointer" v-bind="props">
              <v-btn
                icon="mdi-dots-vertical"
                variant="text"
                v-bind="props"
              ></v-btn>
            </span>
          </template>
          <v-list class="status-list">
            <v-list-item @click="edit = true">
              <span class="d-flex align-center ga-2">
                <span class="d-flex ga-2 align-center"> <span>Edit</span></span>
              </span>
            </v-list-item>
            <v-list-item @click="DeleteComment(comment.id)">
              <span class="d-flex align-center ga-2">
                <span class="d-flex ga-2 align-center">
                  <span>Delete</span></span
                >
              </span>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div
      class="body"
      v-if="comment.comment !== 'undefined'"
      v-html="comment.comment"
    ></div>
    <div class="body">
      <v-row>
        <v-col
          v-for="img in comment.attachments"
          :key="img.id"
          class="d-flex child-flex"
          cols="4"
        >
          <v-img
            @click="showImage(img.file_path)"
            :lazy-src="img.file_path"
            :src="img.file_path"
            aspect-ratio="1"
            class="bg-grey-lighten-2 rounded cursor-pointer w-100"
            cover
          >
            <template v-slot:placeholder>
              <v-row align="center" class="fill-height ma-0" justify="center">
                <v-progress-circular
                  color="grey-lighten-5"
                  indeterminate
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </v-col>
      </v-row>
      <div class="mt-3" v-for="link in comment.links" :key="link">
        <a :href="link.href"> {{ link.name }}</a>
      </div>
    </div>
  </div>
  <div class="create-comments" v-if="edit">
    <TaskEditComment @close="edit = false" :id="comment.id" />
  </div>
  <v-overlay v-model="dialog" location="center" />
  <v-dialog v-model="dialog" width="auto">
    <v-card max-width="auto">
      <template v-slot:text>
        <img width="100%" :src="image_preview" alt="" />
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import apiClient from "@/core/buildRequest";
import { useEditTaskStore } from "@/store/editTaskStore";
import { useGeneralStore } from "@/store/General";
import TaskEditComment from "./TaskEditComment.vue";
export default {
  name: "TaskComment",
  components: { TaskEditComment },
  props: {
    comment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      image_preview: "",
      dialog: false,
      store: useEditTaskStore(),
      general_store: useGeneralStore(),
      edit: false,
    };
  },

  methods: {
    DeleteComment(id) {
      apiClient
        .post(`/calender/tasks/${this.$route.params.id}/delete-comment`, {
          comment_id: id,
        })
        .then((response) => {
          let c = this.store.last_comments.findIndex((item) => item.id === id);
          this.store.last_comments.splice(c, 1);
          this.general_store?.showSnackbar(
            "Comment has been deleted",
            "#237276"
          );
        })
        .catch((error) => {
          console.error("Error sending task:", error);
          this.general_store?.showSnackbar("Error Sending Data", "error");
        });
    },
    showImage(url) {
      this.image_preview = url;
      this.dialog = true;
    },
    test() {
      console.log(this.comment, "asdasdsa");
    },
  },
  mounted() {
    this.test();
  },
};
</script>

<style scoped>
.single-comment {
  padding: 1rem;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-bottom: 1rem;
}

.name {
  font-weight: 500;
}

.time {
  color: #666;
  font-size: 0.9rem;
}

.body {
  color: #333;
  line-height: 1.5;
}

.reply {
  color: #237276;
  cursor: pointer;
  font-weight: 500;
}

.circle-img {
  width: 32px;
  height: 32px;
  border-radius: 50%;
}
</style>
